import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { TimeInput, ToolInfo } from 'components';
import { renderTimes, renderUnitSize } from '../constants';
import { useSelector } from 'react-redux';

export const ActualTimes = ({ inputs, setInputs }) => {
    const { item } = useSelector((state) => ({
        item: state.appointment.appointmentById,
    }));
    const apptUnits = renderUnitSize({ startTime: inputs?.actualStartTime, endTime: inputs?.actualEndTime }, item?.authorizedService);

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    };

    return (
        <div className="actual-time-box">
            <div className="space-between-align-center">
                <div className="service-inputs-box" style={{ alignItems: 'flex-start', width: '65%' }}>
                    <TimeInput
                        label={'Start Time*'}
                        name={'actualStartTime'}
                        onChange={handleChange}
                        defaultValue={inputs?.actualStartTime ? renderTimes(inputs.actualStartTime) || inputs.actualStartTime : null}
                        errorFalse={true}
                    />
                    <div className="full-width">
                        <TimeInput
                            label={'End Time*'}
                            name={'actualEndTime'}
                            onChange={handleChange}
                            defaultValue={inputs?.actualEndTime ? renderTimes(inputs.actualEndTime) || inputs.actualEndTime : null}
                            errorFalse={true}
                        />
                    </div>
                </div>

                <div className="confirm-actual-time">
                    <Checkbox
                        style={{
                            color: inputs?.confirm ? '#0C66E4' : '#D0D5DD',
                            padding: 0,
                        }}
                        checked={inputs?.confirm}
                        onClick={() => {
                            setInputs((prevState) => ({ ...prevState, confirm: !inputs?.confirm }));
                        }}
                    />
                    <p>confirm actual time</p>
                </div>
            </div>

            <div className="space-between-align-center" style={{ marginTop: 12 }}>
                {!inputs?.confirm ? (
                    <div className="actual-time-info">
                        <ToolInfo noTool={true} />
                        <p>You must confirm the actual time before completing</p>
                    </div>
                ) : (
                    <div />
                )}
                {apptUnits && (
                    <div>
                        <p style={{ marginTop: 0 }} className="appt-units">
                            <span style={{ fontWeight: 600 }}>Units: </span>
                            {apptUnits}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
